export enum FeatureAccessConfig {
  PRO = 'fastr-pro',
  VANGUARD = 'fastr-vanguard',
  SHARING_NOTES = 'fastr-ui-shared-notes-with-team',
  SUMMARY_COUNTS = 'fastr-ui-summary-counts',
  RECENT_ROLE_FILTER = 'fastr-ui-recent-role-filter',
  SEATS_MANAGEMENT = 'fastr-ui-seats-management',
  TASKS = 'fastr-ui-tasks',
  CONVERSION_AND_ROI_REPORT = 'conversion-roi-report',
  USAGE_REPORT = 'usage-report',
  PROJECTS_REPORT = 'projects-report',
  LABEL = 'fastr-ui-label',
  CHATBOT = 'fastr-ui-chatbot',
  GMAIL_INTEGRATION = 'fastr-ui-gmail-integration',
  VANGUARD_RECRUITER = 'fastr-vanguard-recruiter-view',
  SLACK_ACCESS = 'fastr-vanguard-slack-access-view',
}
